import "./Spinner.scss";

const Spinner = () => <div className="spinner-norad" />;

export default Spinner;
